import { render, staticRenderFns } from "./AddNewEntity.vue?vue&type=template&id=efc95e3a"
import script from "./AddNewEntity.vue?vue&type=script&lang=js"
export * from "./AddNewEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports